import "./styles.scss";
import { memo, useEffect, useMemo, useState } from "react";



function ListCheckBox(props) {
  const [checkBoxValue, setCheckBoxValue] = useState(props.listTierPicked)
  useEffect(() => {
    //console.log(checkBoxValue)
    const temp = () => props.handleCheckBox
  }, [checkBoxValue])
  function handleChange1(e) {
    //console.log(e.target.checked)
    setCheckBoxValue({ ...checkBoxValue, tier1: e.target.checked })
  }
  function handleChange2(e) {
    //console.log(e.target.checked)
    setCheckBoxValue({ ...checkBoxValue, tier2: e.target.checked })

  }
  function handleChange3(e) {
    //console.log(e.target.checked)
    setCheckBoxValue({ ...checkBoxValue, tier3: e.target.checked })

  }
  function handleChange4(e) {
    //console.log(e.target.checked)
    setCheckBoxValue({ ...checkBoxValue, tier4: e.target.checked })

  }
  function handleChange5(e) {
    //console.log(e.target.checked)
    setCheckBoxValue({ ...checkBoxValue, tier5: e.target.checked })

  }
  function handleChange6(e) {
    //console.log(e.target.checked)
    setCheckBoxValue({ ...checkBoxValue, tier6: e.target.checked })

  }
  function handleChange7(e) {
    //console.log(e.target.checked)
    setCheckBoxValue({ ...checkBoxValue, tier7: e.target.checked })

  }
  function handleChange8(e) {
    //console.log(e.target.checked)
    setCheckBoxValue(prev => { return { ...prev, tier8: e.target.checked } })

  }
  return (
    <>
      <div className="flex sm:flex-col sm:justify-start  flex-row justify-start flex-wrap">
        <div className="mb-[0.9rem]  sm:mr-0 mr-[2.4rem]  ">
          <Checkbox checked={checkBoxValue.tier1} onCheckBoxChange={handleChange1} label='Tier 1' />
        </div>

        <div className="mb-[0.9rem]  sm:mr-0 mr-[2.4rem]  ">
          <Checkbox checked={checkBoxValue.tier2} onCheckBoxChange={handleChange2} label='Tier 2' />
        </div>
        <div className="mb-[0.9rem]  sm:mr-0 mr-[2.4rem]  ">
          <Checkbox checked={checkBoxValue.tier3} onCheckBoxChange={handleChange3} label='Tier 3' />
        </div>
        <div className="mb-[0.9rem]  sm:mr-0 mr-[2.4rem]  ">
          <Checkbox checked={checkBoxValue.tier4} onCheckBoxChange={handleChange4} label='Tier 4' />
        </div>
        <div className="mb-[0.9rem]  sm:mr-0 mr-[2.4rem]  ">
          <Checkbox checked={checkBoxValue.tier5} onCheckBoxChange={handleChange5} label='Tier 5' />
        </div>
        <div className="mb-[0.9rem]  sm:mr-0 mr-[2.4rem]  ">
          <Checkbox checked={checkBoxValue.tier6} onCheckBoxChange={handleChange6} label='Tier 6' />
        </div>
        <div className="mb-[0.9rem]  sm:mr-0 mr-[2.4rem]  ">
          <Checkbox checked={checkBoxValue.tier7} onCheckBoxChange={handleChange7} label='Tier 7' />
        </div>
        <div className="mb-[0.9rem]  sm:mr-0 mr-[2.4rem]  ">
          <Checkbox checked={checkBoxValue.tier8} onCheckBoxChange={handleChange8} label='Tier 8' />
        </div>
      </div>
    </>
  )

}

export default memo(ListCheckBox);


function Checkbox(props) {
  return (
    <>
      <div className="checkbox-wrapper "  >
        <label className="flex justify-start items-center cursor-pointer"  >
          <input className={props.checked ? 'checked' : ""} checked={props.checked} type="checkbox" onChange={props.onCheckBoxChange} />
          <span className="text-white select-none">{props.label}</span>
        </label>
      </div>
    </>
  );
};